// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"488c4b3dc3fe4dd9","9670":"567d5be95c9ad14a"}[chunkId] + ".css";
};